import script from "./OrganismsSubBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrganismsSubBar.vue?vue&type=script&lang=ts&setup=true"

import "./OrganismsSubBar.vue?vue&type=style&index=0&id=2bcf0d30&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2bcf0d30"]])

export default __exports__